import { ComboBox, DefaultButton, DialogFooter, formProperties, IComboBox, Icon, IconButton, IPersonaProps, IPickerItemProps, IStackTokens, ISuggestionItemProps, ISuggestionModel, ISuggestionsProps, ITag, Label, MessageBar, MessageBarType, Modal, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, Pivot, PivotItem, PrimaryButton, Separator, Spinner, SpinnerSize, Stack, TagItemSuggestion, TagPicker, Text, TextField, TimePicker, Toggle, TooltipHost, ValidationState } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks";
import { add, dismissMessage, get, getBaseCurrencies, getQuoteCurrencies, reset, getCategories, getMainPairsItems, resetCategories, resetMainPair, setIsFilteredCategoriesSet, updatePrices, resetBaseCurrencies, resetQuoteCurrencies, setIsFilteredBaseCurrenciesSet, setIsFilteredMainPairsSet, setIsFilteredQuoteCurrenciesSet, setSelectedBaseCurrencyItems, setSelectedCategoryItems, setSelectedQuoteCurrencyItems, setSelecteMainPairItems, setStage1, update } from "./CurrencyPairsFormSlice";
import * as Yup from 'yup';
import { DynamicInputField, InputField } from "../../controls/Controls";
import { inputs } from "../../../../app/Validation";

import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../app/Api";
import { Message } from "../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../FormProps";
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { formatDate, timestampToDate, toFixedWithoutRounding } from "../../../../app/Helpers";
import { AuthenticateReply } from "../../../../repository/UserManagement/authentication_pb";
import { DynamicField } from "../../../common/DynamicFields/DynamicFields";
import { ExtraField } from "../../../../repository/Accountant/common_pb";
import { TableState } from "../../../common/Table/TableSate";
import { AccountStatus, LimitationType, Operations } from "../../../../app/Enums";
import { GetCurrenciesRequest } from "../../../../repository/Accountant/currency_pb"
import { AddCurrencyPairRequest, GetCurrencyPairRequest, UpdateCurrencyPairResponse, AddCurrencyPairResponse, UpdateCurrencyPairRequest, GetCurrencyPairsRequest } from "../../../../repository/Trading/currency_pair_pb";
import { List } from "../../../common/List/List";
import { Popup } from "../../../common/Popup/Popup";
import { CurrenciesPage } from "../../../pages/Accountant/Currencies/CurrenciesPage";
import { GetCategoriesRequest } from "../../../../repository/Trading/category_pb";
import { CurrencyPairsPage } from "../../../pages/Trading/CurrencyPairs/CurrencyPairsPage";
import { CategoriesPage } from "../../../pages/Trading/Categories/CategoriesPage";

let req: AddCurrencyPairRequest;
let updateReq: UpdateCurrencyPairRequest;
let baseCurrenciesReq: GetCurrenciesRequest;
let quoteCurrenciesReq: GetCurrenciesRequest;
let categoriesReq: GetCategoriesRequest;
let mainPairsReq: GetCurrencyPairsRequest;

let promise: any;
let getFilterPromise: any;
let org: number = -1;
let current: AuthenticateReply.AsObject;

export const CurrencyPairsForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();
    const [currentAction, setCurrenctAction] = useState(0)
    const [selectedKey, setSelectedKey] = useState(0);
    const onNextClick = () => {
        setSelectedKey((selectedKey + 1) % 2);
    };
    const onBackClick = () => {
        setSelectedKey((selectedKey - 1) % 2);
    };

    const state: {
        isLoading: boolean, message: ApiMessage | undefined, stage1: any, baseCurrencies: TableState
        quoteCurrencies: TableState,
        categories: TableState,
        mainPairs: TableState

    } = useAppSelector((state) => {

        return {
            isLoading: state.currencyPairsForm.isLoading, message: state.currencyPairsForm.message, stage1: state.currencyPairsForm.stage1,
            baseCurrencies: state.currencyPairsForm.baseCurrencies,
            quoteCurrencies: state.currencyPairsForm.quoteCurrencies,
            categories: state.currencyPairsForm.categories,
            mainPairs: state.currencyPairsForm.mainPairs


        }
    })

    useEffect(() => {
        var l = searchParams.get('org');
        req = new AddCurrencyPairRequest();
        updateReq = new UpdateCurrencyPairRequest()
        baseCurrenciesReq = new GetCurrenciesRequest();
        quoteCurrenciesReq = new GetCurrenciesRequest();
        categoriesReq = new GetCategoriesRequest();
        mainPairsReq = new GetCurrencyPairsRequest();

        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
                baseCurrenciesReq.setOrganization(wrapper)
                quoteCurrenciesReq.setOrganization(wrapper)
                categoriesReq.setOrganization(wrapper)
                mainPairsReq.setOrganization(wrapper)

            }
        }

        if (props.type == FormType.EDIT) {
            if (props.fetchData) {
                let r = new GetCurrencyPairRequest()
                r.setId(props?.renderObject?.id);
                promise?.abort()
                promise = dispatch(get({ body: r, headers: getHeaders() }))
            } else {
                dispatch(setStage1(props?.renderObject))
            }
        }
        const boolv = new BoolValue();
        boolv.setValue(true);
        baseCurrenciesReq.setNumofresults(state.baseCurrencies.numberOfResults)
        baseCurrenciesReq.setOrder(state.baseCurrencies.isDescending)
        baseCurrenciesReq.setIsavailable(boolv)

        quoteCurrenciesReq.setNumofresults(state.quoteCurrencies.numberOfResults)
        quoteCurrenciesReq.setOrder(state.quoteCurrencies.isDescending)
        quoteCurrenciesReq.setIsavailable(boolv)

        categoriesReq.setNumofresults(state.categories.numberOfResults)
        categoriesReq.setOrder(state.categories.isDescending)
        //categoriesReq.setIsavailable(boolv)
        categoriesReq.setOnlysub(boolv)

        mainPairsReq.setNumofresults(state.mainPairs.numberOfResults)
        mainPairsReq.setOrder(state.mainPairs.isDescending)



        if (props.renderObject?.baseCurrencyId) {

            dispatch(setSelectedBaseCurrencyItems(([{ id: props.renderObject.baseCurrencyId, code: props.renderObject.baseCurrencyCode, name: props.renderObject.baseCurrencyName, decimalPlaces: props.renderObject.baseCurrencyDecimalPlaces }])))

        }

        if (props.renderObject?.quoteCurrencyId)
            dispatch(setSelectedQuoteCurrencyItems(([{ id: props.renderObject.quoteCurrencyId, code: props.renderObject.quoteCurrencyCode, name: props.renderObject.quoteCurrencyName, decimalPlaces: props.renderObject.quoteCurrencyDecimalPlaces }])))


        if (props.renderObject?.categoryId)
            dispatch(setSelectedCategoryItems(([{ id: props.renderObject.categoryId, nameAr: props.renderObject.categoryNameAr, nameEn: props.renderObject.categoryNameEn, iconSource: props.renderObject.iconSource }])))


        if (props.renderObject?.mainCurrencyPair)
            dispatch(setSelecteMainPairItems(([{
                id: props.renderObject.mainCurrencyPair,
                name: props.renderObject.mainCurrencyPairName,
                baseCurrencyId: props.renderObject?.mainCurrencyPairBaseCurrencyId,
                baseCurrencyName: props.renderObject?.mainCurrencyPairBaseCurrencyName,
                baseCurrencyCode: props.renderObject?.mainCurrencyPairBaseCurrencyCode,
                baseCurrencyDecimalPlaces: props.renderObject?.mainCurrencyPairBaseCurrencyDecimalPlaces,
                baseCurrencyForm: props.renderObject?.mainCurrencyPairBaseCurrencyForm,
                baseCurrencySymbol: props.renderObject?.mainCurrencyPairBaseCurrencySymbol,
                quoteCurrencyId: props.renderObject?.mainCurrencyPairQuoteCurrencyId,
                quoteCurrencyName: props.renderObject?.mainCurrencyPairQuoteCurrencyName,
                quoteCurrencyCode: props.renderObject?.mainCurrencyPairQuoteCurrencyCode,
                quoteCurrencyDecimalPlaces: props.renderObject?.mainCurrencyPairQuoteCurrencyDecimalPlaces,
                quoteCurrencyForm: props.renderObject?.mainCurrencyPairQuoteCurrencyForm,
                quoteCurrencySymbol: props.renderObject?.mainCurrencyPairQuoteCurrencySymbol,





            }])))

        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            dispatch(reset());
        }
    }, [])


    const baseCurrenciesSuggestionsProps: ISuggestionsProps<ITag> = {
        suggestionsHeaderText: t('currencies'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.baseCurrencies.hasMore && !state.baseCurrencies.isFetching,
        onRenderSuggestion: (props: ITag, suggestionItemProps: ISuggestionItemProps<ITag>) => {
            return <TagItemSuggestion>
                {props?.name ?? props?.key}
            </TagItemSuggestion>
        },
        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.baseCurrencies.items.findIndex(e => e.id == item.key)
            if (u >= 0) {
                dispatch(setSelectedBaseCurrencyItems([state.baseCurrencies.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.baseCurrencies.items.length > 0 && !state.baseCurrencies.isFetching) {
                const wrapper = new StringValue();
                wrapper.setValue(state.baseCurrencies.items.at(state.baseCurrencies.items.length - 1).id);
                baseCurrenciesReq.setNextto(wrapper)
                getFilterPromise = dispatch(getBaseCurrencies({ body: baseCurrenciesReq, headers: getHeaders() }))
            }
        },
        suggestions: state.baseCurrencies.items.length > 0 ? state.baseCurrencies.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : [],
        isLoading: state.baseCurrencies.items.length == 0 ? state.baseCurrencies.isFetching : false,
        isSearching: state.baseCurrencies.items.length > 0 ? state.baseCurrencies.isFetching : false,


    };
    const onBaseCurrenciesFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetBaseCurrencies())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        baseCurrenciesReq.setSearch(wrapper)
        baseCurrenciesReq.setNextto(undefined)
        dispatch(setIsFilteredBaseCurrenciesSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getBaseCurrencies({ body: baseCurrenciesReq, headers: getHeaders() }))
        return [];

    }

    const quoteCurrenciesSuggestionsProps: ISuggestionsProps<ITag> = {
        suggestionsHeaderText: t('currencies'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.quoteCurrencies.hasMore && !state.quoteCurrencies.isFetching,
        onRenderSuggestion: (props: ITag, suggestionItemProps: ISuggestionItemProps<ITag>) => {
            return <TagItemSuggestion>
                {props?.name ?? props?.key}
            </TagItemSuggestion>
        },
        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.quoteCurrencies.items.findIndex(e => e.id == item.key)
            if (u >= 0) {
                dispatch(setSelectedQuoteCurrencyItems([state.quoteCurrencies.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.quoteCurrencies.items.length > 0 && !state.quoteCurrencies.isFetching) {
                const wrapper = new StringValue();
                wrapper.setValue(state.quoteCurrencies.items.at(state.quoteCurrencies.items.length - 1).id);
                quoteCurrenciesReq.setNextto(wrapper)
                getFilterPromise = dispatch(getQuoteCurrencies({ body: quoteCurrenciesReq, headers: getHeaders() }))
            }
        },
        suggestions: state.quoteCurrencies.items.length > 0 ? state.quoteCurrencies.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : [],
        isLoading: state.quoteCurrencies.items.length == 0 ? state.quoteCurrencies.isFetching : false,
        isSearching: state.quoteCurrencies.items.length > 0 ? state.quoteCurrencies.isFetching : false,


    };
    const onQuoteCurrenciesFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetQuoteCurrencies())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        quoteCurrenciesReq.setSearch(wrapper)
        quoteCurrenciesReq.setNextto(undefined)
        dispatch(setIsFilteredQuoteCurrenciesSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getQuoteCurrencies({ body: quoteCurrenciesReq, headers: getHeaders() }))
        return [];

    }
    const onCategoriesFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetCategories())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        categoriesReq.setSearch(wrapper)
        categoriesReq.setNextto(undefined)
        dispatch(setIsFilteredCategoriesSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getCategories({ body: categoriesReq, headers: getHeaders() }))
        return [];

    }

    const onPairsFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetMainPair())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        mainPairsReq.setSearch(wrapper)
        mainPairsReq.setNextto(undefined)
        dispatch(setIsFilteredMainPairsSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getMainPairsItems({ body: mainPairsReq, headers: getHeaders() }))
        return [];


    }
    const snapTimeToUpdatedDateAnchor = (datePickerDate: Date, currentTime: Date) => {
        let snappedTime = new Date(currentTime);

        if (currentTime && !isNaN(currentTime.valueOf())) {
            const startAnchor = new Date(datePickerDate);
            const endAnchor = new Date(startAnchor);
            endAnchor.setDate(startAnchor.getDate() + 1);
            if (currentTime < startAnchor || currentTime > endAnchor) {
                snappedTime = new Date(startAnchor);
                snappedTime.setHours(currentTime.getHours());
                snappedTime.setMinutes(currentTime.getMinutes());
                snappedTime.setSeconds(currentTime.getSeconds());
                snappedTime.setMilliseconds(currentTime.getMilliseconds());
            }
        }

        return snappedTime;
    };

    const hhmmToDate = (hhmm: number): Date => {
        const hours = Math.floor(hhmm / 100);
        const minutes = hhmm % 100;

        const date = new Date();
        date.setHours(hours, minutes, 0, 0); // Set to HH:MM:00.000
        return date;
    }

    const dateToHHMM = (date: Date): number => {
        const hours = date.getHours();
        const minutes = date.getMinutes();


        return hours * 100 + minutes;

    }

    return (
        <>
            <Popup isOpen={(currentAction == 100)} title={t("currencies")} onDismiss={() => { setCurrenctAction(0) }} >

                <CurrenciesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedBaseCurrencyItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 101)} title={t("currencies")} onDismiss={() => { setCurrenctAction(0) }} >

                <CurrenciesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedQuoteCurrencyItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 102)} title={t("categories")} onDismiss={() => { setCurrenctAction(0) }} >

                <CategoriesPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedCategoryItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>


            <Popup isOpen={(currentAction == 103)} title={t("currencyPairs")} onDismiss={() => { setCurrenctAction(0) }} >

                <CurrencyPairsPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelecteMainPairItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Formik
                /*<
    
    
              bool isPriceLimitPercentage = 16;
                        bool isMatchingEngineEnabled = 17;
              bool canClientCancelOrders = 18;
    
    }
                */
                enableReinitialize={true}
                initialValues={{
                    base: undefined,
                    quote: undefined,
                    name: props.renderObject?.name ?? "",
                    sellPrice: (props.renderObject?.sellPrice) ? toFixedWithoutRounding((props.renderObject?.sellPrice), state.quoteCurrencies.selected.at(0)?.decimalPlaces ?? 9) : "",
                    buyPrice: (props.renderObject?.buyPrice) ? toFixedWithoutRounding((props.renderObject?.buyPrice), state.quoteCurrencies.selected.at(0)?.decimalPlaces ?? 9) : "",
                    categories: undefined,
                    icon: (props.renderObject) ? props.renderObject?.iconSource : '',

                    isActive: (props.renderObject) ? props.renderObject.isActive : true,
                    syncPrices: (props.renderObject) ? props.renderObject.syncPrices : false,
                    isPriceLimitPercentage: (props.renderObject) ? props.renderObject.isPriceLimitPercentage ? 1 : 0 : 0,
                    isMatchingEngineEnabled: (props.renderObject) ? props.renderObject.isMatchingEngineEnabled : false,
                    canClientCancelOrders: (props.renderObject) ? props.renderObject.canClientCancelOrders : false,
                    canPlaceOrders: (props.renderObject) ? props.renderObject.canPlaceOrders : false,

                    priceTickSize: (props.renderObject?.priceTickSize) ? toFixedWithoutRounding((props.renderObject?.priceTickSize), state.quoteCurrencies.selected.at(0)?.decimalPlaces ?? 9) : (state.quoteCurrencies.selected.at(0)?.decimalPlaces > 0) ? '0.' + '0'.repeat((state.quoteCurrencies.selected.at(0)?.decimalPlaces ?? 9) - 1) + '1' : "1",
                    quantityTickSize: (props.renderObject?.quantityTickSize) ? toFixedWithoutRounding((props.renderObject?.quantityTickSize), state.baseCurrencies.selected.at(0)?.decimalPlaces ?? 9) : (state.baseCurrencies.selected.at(0)?.decimalPlaces > 0) ? '0.' + '0'.repeat((state.baseCurrencies.selected.at(0)?.decimalPlaces ?? 9) - 1) + '1' : "1",
                    priceMaxLimit: (props.renderObject?.priceMaxLimit && props.renderObject?.isPriceLimitPercentage) ? props.renderObject?.priceMaxLimit : props.renderObject?.priceMaxLimit ? toFixedWithoutRounding((props.renderObject?.priceMaxLimit), state.quoteCurrencies.selected.at(0)?.decimalPlaces ?? 9) : '99999999',
                    priceMinLimit: (props.renderObject?.priceMinLimit && props.renderObject?.isPriceLimitPercentage) ? props.renderObject?.priceMinLimit : props.renderObject?.priceMinLimit ? toFixedWithoutRounding((props.renderObject?.priceMinLimit), state.quoteCurrencies.selected.at(0)?.decimalPlaces ?? 9) : (state.quoteCurrencies.selected.at(0)?.decimalPlaces > 0) ? '0.' + '0'.repeat((state.quoteCurrencies.selected.at(0)?.decimalPlaces ?? 9) - 1) + '1' : "1",
                    quantityMaxLimit: (props.renderObject?.quantityMaxLimit) ? toFixedWithoutRounding((props.renderObject?.quantityMaxLimit), state.baseCurrencies.selected.at(0)?.decimalPlaces ?? 9) : '99999999',
                    quantityMinLimit: (props.renderObject?.quantityMinLimit) ? toFixedWithoutRounding((props.renderObject?.quantityMinLimit), state.baseCurrencies.selected.at(0)?.decimalPlaces ?? 9) : (state.baseCurrencies.selected.at(0)?.decimalPlaces > 0) ? '0.' + '0'.repeat((state.baseCurrencies.selected.at(0)?.decimalPlaces ?? 9) - 1) + '1' : "1",
                    openingDay: (props.renderObject) ? props.renderObject?.openingDay : undefined,
                    tradingDays: (props.renderObject) ? props.renderObject?.tradingDays && props.renderObject?.tradingDays.length == 7 ? props.renderObject?.tradingDays.map((val: any, i: any) => val ? i : null)
                        .filter((v: any) => v !== null) : [true, true, true, true, true, true, true] : [true, true, true, true, true, true, true],
                    tradingHours: (props.renderObject) ? props.renderObject?.tradingHours && props.renderObject?.tradingHours.length == 2 ? props.renderObject?.tradingHours : [0, 2359] : [0, 2359],
                    infoURL: (props.renderObject) ? props.renderObject?.infoURL : '',
                }}

                validationSchema={Yup.object({
                    name: inputs.namePair,
                    buyPrice: inputs.buyPrice,
                    sellPrice: inputs.sellPrice,
                    icon: inputs.currencyIcon,
                    infoURL: inputs.currencyIcon,
                    quantityMinLimit: inputs.amount,
                    quantityMaxLimit: inputs.amount,
                    priceMaxLimit: inputs.amount,
                    priceMinLimit: inputs.amount,
                    quantityTickSize: inputs.amount,
                    priceTickSize: inputs.amount,
                })}

                onSubmit={(values, actions) => {
                    if (selectedKey == 0) {


                        onNextClick();
                        return;
                    }
                    if (props.type == FormType.ADD) {

                        let quote = state.quoteCurrencies.selected.at(0);
                        let base = state.baseCurrencies.selected.at(0);
                        let category = state.categories.selected.at(0);

                        if (base.id == quote.id) {
                            dispatch(setSelectedQuoteCurrencyItems([]))
                            return;
                        }


                        req.setBasecurrency(base?.id);
                        req.setQuotecurrency(quote?.id);
                        req.setName(values.name?.trim());
                        req.setCategory(category?.id);
                        req.setIconsource(values.icon)

                        req.setBuyprice(values.buyPrice?.trim()?.replace(/,/g, ''))
                        req.setSellprice(values.sellPrice?.trim()?.replace(/,/g, ''))
                        req.setIsactive(values.isActive);

                        req.setSyncprices(values.syncPrices)

                        req.setIsmatchingengineenabled(values.isMatchingEngineEnabled)
                        req.setCanclientcancelorders(values.canClientCancelOrders)
                        req.setCanplaceorders(values.canPlaceOrders)

                        req.setIspricelimitpercentage(values.isPriceLimitPercentage == 1)
                        req.setQuantitymaxlimit(values.quantityMaxLimit?.trim()?.replace(/,/g, ''))
                        req.setQuantityminlimit(values.quantityMinLimit?.trim()?.replace(/,/g, ''))
                        req.setPricemaxlimit(values.priceMaxLimit?.trim()?.replace(/,/g, ''))
                        req.setPriceminlimit(values.priceMinLimit?.trim()?.replace(/,/g, ''))
                        req.setPriceticksize(values.priceTickSize?.trim()?.replace(/,/g, ''))
                        req.setQuantityticksize(values.quantityTickSize?.trim()?.replace(/,/g, ''))
                        req.setInfourl(values.infoURL)

                        const week: boolean[] = new Array(7).fill(false);

                        // Set the days in the input array to true
                        values.tradingDays.forEach((day: any) => {
                            if (day >= 0 && day < 7) {  // Ensure the day index is valid (0-6)
                                week[day] = true;
                            }
                        });

                        req.setTradingdaysList(week);
                        req.setOpeningday(values.openingDay);
                        req.setTradinghoursList(values.tradingHours);

                        promise = dispatch(add({ body: req, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: AddCurrencyPairResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            id: res.success?.id,
                                            name: values.name?.trim(),
                                            buyPrice: values.buyPrice?.replace(/,/g, ''),
                                            sellPrice: values.sellPrice?.replace(/,/g, ''),
                                            tradingPrice: values.sellPrice?.replace(/,/g, ''),
                                            iconSource: values.icon,
                                            categoryId: category?.id,
                                            categoryNameAr: category?.nameAr,
                                            categoryNameEn: category?.nameEn,
                                            isActive: values.isActive,
                                            syncPrices: values.syncPrices,
                                            baseCurrencyId: base?.id ?? "",
                                            baseCurrencyName: base?.name ?? "",
                                            baseCurrencyCode: base?.code ?? "",
                                            baseCurrencyDecimalPlaces: base?.decimalPlaces ?? undefined,
                                            baseCurrencyForm: base?.form ?? undefined,
                                            baseCurrencySymbol: base?.symbol ?? undefined,
                                            quoteCurrencyId: quote?.id ?? "",
                                            quoteCurrencyName: quote?.name ?? "",
                                            quoteCurrencyCode: quote?.code ?? "",
                                            quoteCurrencyDecimalPlaces: quote?.decimalPlaces ?? undefined,
                                            quoteCurrencyForm: quote?.form ?? undefined,
                                            quoteCurrencySymbol: quote?.symbol ?? "",
                                            priceUpdate: formatDate(timestampToDate(res.success?.createddate?.seconds, res.success?.createddate?.nanos)),
                                            createdDate: formatDate(timestampToDate(res.success?.createddate?.seconds, res.success?.createddate?.nanos)),
                                            addedBy: (current.profile?.firstname?.value ?? "") + " " + (current.profile?.lastname?.value ?? ""),
                                            addedById: current.profile?.id?.value,

                                            isPriceLimitPercentage: values.isPriceLimitPercentage == 1,
                                            isMatchingEngineEnabled: values.isMatchingEngineEnabled,
                                            canClientCancelOrders: values.canClientCancelOrders,
                                            canPlaceOrders: values.canPlaceOrders,

                                            priceTickSize: values.priceTickSize?.replace(/,/g, ''),
                                            quantityTickSize: values.quantityTickSize?.replace(/,/g, ''),
                                            priceMinLimit: values.priceMinLimit?.replace(/,/g, ''),
                                            priceMaxLimit: values.priceMaxLimit?.replace(/,/g, ''),
                                            quantityMaxLimit: values.quantityMaxLimit?.replace(/,/g, ''),
                                            quantityMinLimit: values.quantityMinLimit?.replace(/,/g, ''),
                                            tradingHours: values.tradingHours,
                                            tradingDays: week,
                                            infoURL: values.infoURL,
                                            openingDay: values.openingDay

                                        });
                                    }
                                }
                                actions.setSubmitting(false)


                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    } else {
                        updateReq.setId(props.renderObject?.id);
                        updateReq.setName(values.name?.trim())
                        updateReq.setSyncprices(values.syncPrices)
                        let category = state.categories.selected.at(0);

                        updateReq.setCategory(category?.id);
                        updateReq.setIconsource(values.icon)

                        updateReq.setIsmatchingengineenabled(values.isMatchingEngineEnabled)
                        updateReq.setCanclientcancelorders(values.canClientCancelOrders)
                        updateReq.setCanplaceorders(values.canPlaceOrders)

                        updateReq.setIspricelimitpercentage(values.isPriceLimitPercentage == 1)
                        updateReq.setQuantitymaxlimit(values.quantityMaxLimit?.trim()?.replace(/,/g, ''))
                        updateReq.setQuantityminlimit(values.quantityMinLimit?.trim()?.replace(/,/g, ''))
                        updateReq.setPricemaxlimit(values.priceMaxLimit?.trim()?.replace(/,/g, ''))
                        updateReq.setPriceminlimit(values.priceMinLimit?.trim()?.replace(/,/g, ''))
                        updateReq.setPriceticksize(values.priceTickSize?.trim()?.replace(/,/g, ''))
                        updateReq.setQuantityticksize(values.quantityTickSize?.trim()?.replace(/,/g, ''))

                        const week: boolean[] = new Array(7).fill(false);

                        // Set the days in the input array to true
                        values.tradingDays.forEach((day: any) => {
                            if (day >= 0 && day < 7) {  // Ensure the day index is valid (0-6)
                                week[day] = true;
                            }
                        });

                        updateReq.setTradingdaysList(week);
                        updateReq.setOpeningday(values.openingDay);
                        updateReq.setTradinghoursList(values.tradingHours);
                        updateReq.setInfourl(values.infoURL);

                        promise = dispatch(update({ body: updateReq, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: UpdateCurrencyPairResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            ...props.renderObject,
                                            name: values.name?.trim(),
                                            syncPrices: values.syncPrices,
                                            iconSource: values.icon,
                                            categoryId: category?.id,
                                            categoryNameAr: category?.nameAr,
                                            categoryNameEn: category?.nameEn,

                                            isPriceLimitPercentage: values.isPriceLimitPercentage == 1,
                                            isMatchingEngineEnabled: values.isMatchingEngineEnabled,
                                            canClientCancelOrders: values.canClientCancelOrders,
                                            canPlaceOrders: values.canPlaceOrders,
                                            priceTickSize: values.priceTickSize?.replace(/,/g, ''),
                                            quantityTickSize: values.quantityTickSize?.replace(/,/g, ''),
                                            priceMinLimit: values.priceMinLimit?.replace(/,/g, ''),
                                            priceMaxLimit: values.priceMaxLimit?.replace(/,/g, ''),
                                            quantityMaxLimit: values.quantityMaxLimit?.replace(/,/g, ''),
                                            quantityMinLimit: values.quantityMinLimit?.replace(/,/g, ''),
                                            tradingHours: values.tradingHours,
                                            tradingDays: week,
                                            infoURL: values.infoURL,
                                            openingDay: values.openingDay


                                        });
                                    }
                                }
                                actions.setSubmitting(false)
                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    }
                }}

            >
                {formkikProps => (
                    <Form onSubmit={(e) => {
                        e.preventDefault()

                        formkikProps.validateForm().then(e => {
                            if (e.name || e.categories || e.icon) {
                            } else {
                                if (selectedKey == 0)
                                    onNextClick();
                                else formkikProps.submitForm();


                            }
                        });

                    }
                    }>
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }

                            <Pivot selectedKey={String(selectedKey)} >
                                <PivotItem headerText={t("pairInfo")} itemKey="0" >
                                    <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >

                                        {props.type == FormType.ADD ? <Stack>
                                            <Label required
                                                disabled={state.isLoading}>{t("baseCurrency")}</Label>
                                            <List
                                                inputProps={{ placeholder: t("baseCurrency"), required: true }}
                                                disabled={state.isLoading}
                                                suggestionsHeaderText={t('currencies')}
                                                isLoading={state.baseCurrencies.items.length == 0 ? state.baseCurrencies.isFetching : false}
                                                isSearching={state.baseCurrencies.items.length > 0 ? state.baseCurrencies.isFetching : false}
                                                moreSuggestionsAvailable={state.baseCurrencies.hasMore && !state.baseCurrencies.isFetching}
                                                suggestions={state.baseCurrencies.items.length > 0 ? state.baseCurrencies.items.map(e => { return { item: { key: e.id, text: e.name, imageInitials: e?.symbol, secondaryText: e?.code, imageUrl: e?.icon } } as ISuggestionModel<IPersonaProps> }) : []}
                                                onGetMoreResults={() => {
                                                    if (state.baseCurrencies.items.length > 0 && !state.baseCurrencies.isFetching) {
                                                        const wrapper = new StringValue();
                                                        wrapper.setValue(state.baseCurrencies.items.at(state.baseCurrencies.items.length - 1).id);
                                                        baseCurrenciesReq.setNextto(wrapper)
                                                        getFilterPromise = dispatch(getBaseCurrencies({ body: baseCurrenciesReq, headers: getHeaders() }))
                                                    }
                                                }}
                                                onSuggestionClick={(ev?, item?: any, index?: number) => {

                                                    var u = state.baseCurrencies.items.findIndex(e => e.id == item.key)
                                                    if (u >= 0) {
                                                        dispatch(setSelectedBaseCurrencyItems([state.baseCurrencies.items.at(u)]))
                                                        let quote = state.quoteCurrencies.selected.at(0);
                                                        let base = state.baseCurrencies.items.at(u);
                                                        if (quote != undefined && base != undefined && formkikProps.values.name?.length == 0) {
                                                            formkikProps.setFieldValue("name", (base?.name == "" ? base?.id : base?.name + " (" + base?.code + ")") + " / " + (quote?.name == "" ? quote?.id : quote?.name + " (" + quote?.code + ")"))
                                                        }
                                                    }

                                                }}
                                                isPeoplePicker={true}
                                                selectedItems={state.baseCurrencies.selected.length > 0 ? state.baseCurrencies.selected.map(e => { return { key: e.id, text: e.name, imageInitials: e?.symbol, secondaryText: e?.code, imageUrl: e?.icon } as IPersonaProps }) : []}
                                                onChange={(e) => {
                                                    dispatch(setSelectedBaseCurrencyItems([]))

                                                }}
                                                onEmptyInputFocus={() => {
                                                    dispatch(resetBaseCurrencies())
                                                    baseCurrenciesReq.setSearch(undefined)
                                                    baseCurrenciesReq.setNextto(undefined)
                                                    dispatch(setIsFilteredBaseCurrenciesSet(false))
                                                    getFilterPromise?.abort()
                                                    getFilterPromise = dispatch(getBaseCurrencies({ body: baseCurrenciesReq, headers: getHeaders() }))
                                                    return []

                                                }}
                                                onFilterChanged={onBaseCurrenciesFilterChanged}
                                                endButtons={[
                                                    {
                                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                        onClick: () => {
                                                            setCurrenctAction(100)

                                                        }
                                                    }]}
                                            />
                                        </Stack> : undefined}


                                        {props.type == FormType.ADD ? <Stack>
                                            <Label required
                                                disabled={state.isLoading}>{t("quoteCurrency")}</Label>
                                            <List
                                                inputProps={{ placeholder: t("quoteCurrency"), required: true }}
                                                disabled={state.isLoading}
                                                suggestionsHeaderText={t('currencies')}
                                                isLoading={state.quoteCurrencies.items.length == 0 ? state.quoteCurrencies.isFetching : false}
                                                isSearching={state.quoteCurrencies.items.length > 0 ? state.quoteCurrencies.isFetching : false}
                                                moreSuggestionsAvailable={state.quoteCurrencies.hasMore && !state.quoteCurrencies.isFetching}
                                                suggestions={state.quoteCurrencies.items.length > 0 ? state.quoteCurrencies.items.map(e => { return { item: { key: e.id, text: e.name, imageInitials: e?.symbol, secondaryText: e?.code, imageUrl: e?.icon } } as ISuggestionModel<IPersonaProps> }) : []}

                                                onGetMoreResults={() => {
                                                    if (state.quoteCurrencies.items.length > 0 && !state.quoteCurrencies.isFetching) {
                                                        const wrapper = new StringValue();
                                                        wrapper.setValue(state.quoteCurrencies.items.at(state.quoteCurrencies.items.length - 1).id);
                                                        quoteCurrenciesReq.setNextto(wrapper)
                                                        getFilterPromise = dispatch(getQuoteCurrencies({ body: quoteCurrenciesReq, headers: getHeaders() }))
                                                    }
                                                }}
                                                onSuggestionClick={(ev?, item?: any, index?: number) => {

                                                    var u = state.quoteCurrencies.items.findIndex(e => e.id == item.key)
                                                    if (u >= 0) {
                                                        dispatch(setSelectedQuoteCurrencyItems([state.quoteCurrencies.items.at(u)]))
                                                        let quote = state.quoteCurrencies.items.at(u);
                                                        let base = state.baseCurrencies.selected.at(0);
                                                        if (quote != undefined && base != undefined && formkikProps.values.name?.length == 0) {
                                                            formkikProps.setFieldValue("name", (base?.name == "" ? base?.id : base?.name + " (" + base?.code + ")") + " / " + (quote?.name == "" ? quote?.id : quote?.name + " (" + quote?.code + ")"))
                                                        }
                                                    }

                                                }}
                                                isPeoplePicker={true}
                                                selectedItems={state.quoteCurrencies.selected.length > 0 ? state.quoteCurrencies.selected.map(e => { return { key: e.id, text: e.name, imageInitials: e?.symbol, secondaryText: e?.code, imageUrl: e?.icon } as IPersonaProps }) : []}
                                                onChange={(e) => {
                                                    dispatch(setSelectedQuoteCurrencyItems([]))

                                                }}
                                                onEmptyInputFocus={() => {
                                                    dispatch(resetQuoteCurrencies())
                                                    quoteCurrenciesReq.setSearch(undefined)
                                                    quoteCurrenciesReq.setNextto(undefined)
                                                    dispatch(setIsFilteredQuoteCurrenciesSet(false))
                                                    getFilterPromise?.abort()
                                                    getFilterPromise = dispatch(getQuoteCurrencies({ body: quoteCurrenciesReq, headers: getHeaders() }))
                                                    return []

                                                }}
                                                onFilterChanged={onQuoteCurrenciesFilterChanged}
                                                endButtons={[
                                                    {
                                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                        onClick: () => {
                                                            setCurrenctAction(101)

                                                        }
                                                    }]}
                                            />
                                        </Stack> : undefined}

                                        <Field name="name" label={t("pairName")} placeholder={t("pairNameHint")} component={InputField} disabled={state.isLoading} maxLength={200} required />

                                        <Stack>
                                            <Label required
                                                disabled={state.isLoading}>{t("category")}</Label>
                                            <List
                                                inputProps={{ placeholder: t("category"), required: true }}
                                                disabled={state.isLoading}
                                                suggestionsHeaderText={t('categories')}
                                                isLoading={state.categories.items.length == 0 ? state.categories.isFetching : false}
                                                isSearching={state.categories.items.length > 0 ? state.categories.isFetching : false}
                                                moreSuggestionsAvailable={state.categories.hasMore && !state.categories.isFetching}
                                                suggestions={state.categories.items.length > 0 ? state.categories.items.map(e => { return { item: { key: e.id, text: e.nameAr + " | " + e.nameEn, imageInitials: (e.parentCategoryNameAr == "" && e.parentCategoryNameEn == "" ? undefined : (e.parentCategoryNameAr ?? "") + " | " + (e.parentCategoryNameEn ?? "")), secondaryText: e.parentCategoryId == undefined ? undefined : e.parentCategoryNameAr == "" && e.parentCategoryNameEn == "" ? undefined : e.parentCategoryNameAr + " | " + e.parentCategoryNameEn, imageUrl: e?.iconSource } } as ISuggestionModel<IPersonaProps> }) : []}
                                                onGetMoreResults={() => {
                                                    if (state.categories.items.length > 0 && !state.categories.isFetching) {
                                                        const wrapper = new StringValue();
                                                        wrapper.setValue(state.categories.items.at(state.categories.items.length - 1).id);
                                                        categoriesReq.setNextto(wrapper)
                                                        getFilterPromise = dispatch(getCategories({ body: categoriesReq, headers: getHeaders() }))
                                                    }
                                                }}
                                                onSuggestionClick={(ev?, item?: any, index?: number) => {

                                                    var u = state.categories.items.findIndex(e => e.id == item.key)
                                                    if (u >= 0) {
                                                        dispatch(setSelectedCategoryItems([state.categories.items.at(u)]))

                                                    }

                                                }}
                                                isPeoplePicker={true}
                                                selectedItems={state.categories.selected.length > 0 ? state.categories.selected.map(e => { return { key: e.id, text: e.nameAr + " | " + e.nameEn, imageInitials: (e.parentCategoryNameAr == "" && e.parentCategoryNameEn == "" ? undefined : (e.parentCategoryNameAr ?? "") + " | " + (e.parentCategoryNameEn ?? "")), secondaryText: e.parentCategoryId == undefined ? undefined : e.parentCategoryNameAr == "" && e.parentCategoryNameEn == "" ? undefined : e.parentCategoryNameAr + " | " + e.parentCategoryNameEn, imageUrl: e?.iconSource } as IPersonaProps }) : []}
                                                onChange={(e) => {
                                                    dispatch(setSelectedCategoryItems([]))

                                                }}
                                                onEmptyInputFocus={() => {
                                                    dispatch(resetCategories())
                                                    categoriesReq.setSearch(undefined)
                                                    categoriesReq.setNextto(undefined)
                                                    dispatch(setIsFilteredCategoriesSet(false))
                                                    getFilterPromise?.abort()
                                                    getFilterPromise = dispatch(getCategories({ body: categoriesReq, headers: getHeaders() }))
                                                    return []

                                                }}
                                                onFilterChanged={onCategoriesFilterChanged}
                                                endButtons={[
                                                    {
                                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                        onClick: () => {
                                                            setCurrenctAction(102)

                                                        }
                                                    }]}
                                            />
                                        </Stack>
                                        <Field name="infoURL" label={<div>
                                            {t("infoURL") + ' '}
                                            <TooltipHost content={t("infoURLDesc")}>
                                                <Icon iconName="Info" aria-label={t("infoURL")} />
                                            </TooltipHost>
                                        </div>} placeholder={"https://markets.com/usdlyd"} component={InputField} disabled={state.isLoading} maxLength={2048} />

                                        <Field name="icon" label={t("currencyIcon")} placeholder={"https://icons.com/usd.png"} component={InputField} disabled={state.isLoading} maxLength={2048} />

                                        {props.type == FormType.ADD ? <Stack horizontal horizontalAlign="space-between"  >
                                            <Stack.Item grow>
                                                <Field name="buyPrice" label={t("buyPrice")} placeholder={t("buyPrice")}
                                                    component={InputField} disabled={state.isLoading} maxLength={15}
                                                    onBlur={(event: any) => {
                                                        if (isNaN(Number(formkikProps.values.buyPrice?.replace(/,/g, '')))) {
                                                            formkikProps.handleBlur(event);
                                                            return;
                                                        }
                                                        let quote = state.quoteCurrencies.selected.at(0);
                                                        if (quote)
                                                            formkikProps.setFieldValue("buyPrice", toFixedWithoutRounding((formkikProps.values.buyPrice?.replace(/,/g, '')), quote?.decimalPlaces ?? 9))
                                                        else
                                                            formkikProps.setFieldValue("buyPrice", toFixedWithoutRounding((formkikProps.values.buyPrice?.replace(/,/g, '')), 9))
                                                        formkikProps.handleBlur(event);
                                                    }}
                                                    required />
                                            </Stack.Item>
                                            <Stack.Item grow>
                                                <Field name="sellPrice" label={t("sellPrice")} placeholder={t("sellPrice")}
                                                    component={InputField} disabled={state.isLoading} maxLength={15}
                                                    onBlur={(event: any) => {
                                                        if (isNaN(Number(formkikProps.values.sellPrice?.replace(/,/g, '')))) {
                                                            formkikProps.handleBlur(event);
                                                            return;
                                                        }
                                                        let quote = state.quoteCurrencies.selected.at(0);
                                                        if (quote)
                                                            formkikProps.setFieldValue("sellPrice", toFixedWithoutRounding((formkikProps.values.sellPrice?.replace(/,/g, '')), quote?.decimalPlaces ?? 9))
                                                        else
                                                            formkikProps.setFieldValue("sellPrice", toFixedWithoutRounding((formkikProps.values.sellPrice?.replace(/,/g, '')), 9))
                                                        formkikProps.handleBlur(event);
                                                    }}
                                                    required />
                                            </Stack.Item>

                                        </Stack> : undefined}
                                        {props.type == FormType.ADD ? <Toggle

                                            onText={t("active")} offText={t("inactive")}
                                            label={t("status")}
                                            disabled={state.isLoading}

                                            checked={formkikProps.values.isActive}
                                            onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                                formkikProps.setFieldValue('isActive', checked);
                                            }
                                            }
                                        /> : undefined}

                                        <Toggle

                                            onText={t("active")} offText={t("inactive")}
                                            label={<div>
                                                {t("syncPrices") + ' '}
                                                <TooltipHost content={t("syncPricesHint")}>
                                                    <Icon iconName="Info" aria-label={t("syncPrices")} />
                                                </TooltipHost>
                                            </div>}
                                            disabled={state.isLoading}
                                            checked={formkikProps.values.syncPrices}
                                            onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                                formkikProps.setFieldValue('syncPrices', checked);
                                            }
                                            }
                                        />
                                    </Stack>
                                </PivotItem>
                                <PivotItem headerText={t("tradingSettings")} itemKey="1">
                                    <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >

                                        <Stack horizontal horizontalAlign="space-between" >
                                            <Stack.Item grow>
                                                <Field name="priceTickSize" label={<div>
                                                    {t("priceTickSize") + ' '}
                                                    <TooltipHost content={t("priceTickSizeDesc")}>
                                                        <Icon iconName="Info" aria-label={t("priceTickSize")} />
                                                    </TooltipHost>
                                                </div>} placeholder={0.005}
                                                    onBlur={(event: any) => {
                                                        if (isNaN(Number(formkikProps.values.priceTickSize?.replace(/,/g, '')))) {
                                                            formkikProps.handleBlur(event);
                                                            return;
                                                        }
                                                        let quote = state.quoteCurrencies.selected.at(0);
                                                        if (quote)
                                                            formkikProps.setFieldValue("priceTickSize", toFixedWithoutRounding((formkikProps.values.priceTickSize?.replace(/,/g, '')), quote?.decimalPlaces ?? 9))
                                                        else
                                                            formkikProps.setFieldValue("priceTickSize", toFixedWithoutRounding((formkikProps.values.priceTickSize?.replace(/,/g, '')), 9))
                                                        formkikProps.handleBlur(event);
                                                    }} component={InputField} disabled={state.isLoading} maxLength={15}

                                                />
                                            </Stack.Item>
                                            <Stack.Item grow>
                                                <Field name="quantityTickSize" label={<div>
                                                    {t("quantityTickSize") + ' '}
                                                    <TooltipHost content={t("quantityTickSizeDesc")}>
                                                        <Icon iconName="Info" aria-label={t("quantityTickSize")} />
                                                    </TooltipHost>
                                                </div>} placeholder={100}
                                                    component={InputField} onBlur={(event: any) => {
                                                        if (isNaN(Number(formkikProps.values.quantityTickSize?.replace(/,/g, '')))) {
                                                            formkikProps.handleBlur(event);
                                                            return;
                                                        }
                                                        let quote = state.baseCurrencies.selected.at(0);
                                                        if (quote)
                                                            formkikProps.setFieldValue("quantityTickSize", toFixedWithoutRounding((formkikProps.values.quantityTickSize?.replace(/,/g, '')), quote?.decimalPlaces ?? 9))
                                                        else
                                                            formkikProps.setFieldValue("quantityTickSize", toFixedWithoutRounding((formkikProps.values.quantityTickSize?.replace(/,/g, '')), 9))
                                                        formkikProps.handleBlur(event);
                                                    }} disabled={state.isLoading} maxLength={15}

                                                />
                                            </Stack.Item>


                                        </Stack>

                                        <Stack horizontal horizontalAlign="space-between" >
                                            <Stack.Item grow>
                                                <Field name="quantityMinLimit" label={t("quantityMinLimit")} placeholder={t("quantityMinLimit")}
                                                    component={InputField} disabled={state.isLoading} maxLength={15} suffix={state.baseCurrencies?.selected?.at(0)?.code ?? ""}
                                                    onBlur={(event: any) => {
                                                        if (isNaN(Number(formkikProps.values.quantityMinLimit?.replace(/,/g, '')))) {
                                                            formkikProps.handleBlur(event);
                                                            return;
                                                        }
                                                        let quote = state.baseCurrencies.selected.at(0);
                                                        if (quote)
                                                            formkikProps.setFieldValue("quantityMinLimit", toFixedWithoutRounding((formkikProps.values.quantityMinLimit?.replace(/,/g, '')), quote?.decimalPlaces ?? 9))
                                                        else
                                                            formkikProps.setFieldValue("quantityMinLimit", toFixedWithoutRounding((formkikProps.values.quantityMinLimit?.replace(/,/g, '')), 9))
                                                        formkikProps.handleBlur(event);
                                                    }}
                                                />
                                            </Stack.Item>
                                            <Stack.Item grow>
                                                <Field name="quantityMaxLimit" label={t("quantityMaxLimit")} placeholder={t("quantityMaxLimit")}
                                                    component={InputField} disabled={state.isLoading} maxLength={15} suffix={state.baseCurrencies?.selected?.at(0)?.code ?? ""}
                                                    onBlur={(event: any) => {
                                                        if (isNaN(Number(formkikProps.values.quantityMaxLimit?.replace(/,/g, '')))) {
                                                            formkikProps.handleBlur(event);
                                                            return;
                                                        }
                                                        let quote = state.baseCurrencies.selected.at(0);
                                                        if (quote)
                                                            formkikProps.setFieldValue("quantityMaxLimit", toFixedWithoutRounding((formkikProps.values.quantityMaxLimit?.replace(/,/g, '')), quote?.decimalPlaces ?? 9))
                                                        else
                                                            formkikProps.setFieldValue("quantityMaxLimit", toFixedWithoutRounding((formkikProps.values.quantityMaxLimit?.replace(/,/g, '')), 9))
                                                        formkikProps.handleBlur(event);
                                                    }}
                                                />
                                            </Stack.Item>

                                        </Stack>

                                        <ComboBox
                                            label={t("isPriceLimitPercentage")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("fixed") }, { key: 1, text: t("percentage") },
                                            ]}
                                            selectedKey={formkikProps.values?.isPriceLimitPercentage}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`isPriceLimitPercentage`, o?.key)


                                            }}
                                        // Force re-creating the component when the toggles change (for demo purposes)
                                        />
                                        <Stack horizontal horizontalAlign="space-between"  >
                                            <Stack.Item grow>
                                                <Field name="priceMinLimit" label={t("priceMinLimit")} placeholder={t("priceMinLimit")}
                                                    component={InputField} disabled={state.isLoading} maxLength={15} suffix={formkikProps.values?.isPriceLimitPercentage == 1 ? "%" : state.quoteCurrencies?.selected?.at(0)?.code ?? ""}
                                                    onBlur={(event: any) => {
                                                        if (isNaN(Number(formkikProps.values.priceMinLimit?.replace(/,/g, '')))) {
                                                            formkikProps.handleBlur(event);
                                                            return;
                                                        }
                                                        if (formkikProps.values?.isPriceLimitPercentage == 0) {
                                                            let quote = state.quoteCurrencies.selected.at(0);
                                                            if (quote)
                                                                formkikProps.setFieldValue("priceMinLimit", toFixedWithoutRounding((formkikProps.values.priceMinLimit?.replace(/,/g, '')), quote?.decimalPlaces ?? 9))
                                                            else
                                                                formkikProps.setFieldValue("priceMinLimit", toFixedWithoutRounding((formkikProps.values.priceMinLimit?.replace(/,/g, '')), 9))
                                                        } else {
                                                            formkikProps.setFieldValue("priceMinLimit", toFixedWithoutRounding((formkikProps.values.priceMinLimit?.replace(/,/g, '')), 2))
                                                        }
                                                        formkikProps.handleBlur(event);
                                                    }
                                                    }
                                                />
                                            </Stack.Item>
                                            <Stack.Item grow>
                                                <Field name="priceMaxLimit" label={t("priceMaxLimit")} placeholder={t("priceMaxLimit")}
                                                    component={InputField} disabled={state.isLoading} maxLength={15} suffix={formkikProps.values?.isPriceLimitPercentage == 1 ? "%" : state.quoteCurrencies?.selected?.at(0)?.code ?? ""}
                                                    onBlur={(event: any) => {
                                                        if (isNaN(Number(formkikProps.values.quantityMaxLimit?.replace(/,/g, '')))) {
                                                            formkikProps.handleBlur(event);
                                                            return;
                                                        }
                                                        if (formkikProps.values?.isPriceLimitPercentage == 0) {
                                                            let quote = state.quoteCurrencies.selected.at(0);
                                                            if (quote)
                                                                formkikProps.setFieldValue("priceMaxLimit", toFixedWithoutRounding((formkikProps.values.priceMaxLimit?.replace(/,/g, '')), quote?.decimalPlaces ?? 9))
                                                            else
                                                                formkikProps.setFieldValue("priceMaxLimit", toFixedWithoutRounding((formkikProps.values.priceMaxLimit?.replace(/,/g, '')), 9))
                                                        } else {
                                                            formkikProps.setFieldValue("priceMaxLimit", toFixedWithoutRounding((formkikProps.values.priceMaxLimit?.replace(/,/g, '')), 2))

                                                        }
                                                        formkikProps.handleBlur(event);
                                                    }}
                                                />
                                            </Stack.Item>


                                        </Stack>




                                        <Toggle

                                            onText={t("active")} offText={t("inactive")}
                                            label={<div>
                                                {t("canPlaceOrders") + ' '}
                                                <TooltipHost content={t("canPlaceOrdersDesc")}>
                                                    <Icon iconName="Info" aria-label={t("canPlaceOrders")} />
                                                </TooltipHost>
                                            </div>}
                                            disabled={state.isLoading}
                                            checked={formkikProps.values.canPlaceOrders}
                                            onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                                formkikProps.setFieldValue('canPlaceOrders', checked);
                                            }
                                            }
                                        />

                                        <Toggle

                                            onText={t("enabled")} offText={t("disabled")}
                                            label={<div>
                                                {t("canClientCancelOrder") + ' '}
                                                <TooltipHost content={t("canClientCancelOrderDesc")}>
                                                    <Icon iconName="Info" aria-label={t("canClientCancelOrder")} />
                                                </TooltipHost>
                                            </div>}
                                            disabled={state.isLoading}
                                            checked={formkikProps.values.canClientCancelOrders}
                                            onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                                formkikProps.setFieldValue('canClientCancelOrders', checked);
                                            }
                                            }
                                        />

                                        <Toggle

                                            onText={t("active")} offText={t("inactive")}
                                            label={<div>
                                                {t("isMatchingEngineEnabled") + ' '}
                                                <TooltipHost content={t("isMatchingEngineEnabledDesc")}>
                                                    <Icon iconName="Info" aria-label={t("isMatchingEngineEnabled")} />
                                                </TooltipHost>
                                            </div>}
                                            disabled={state.isLoading}
                                            checked={formkikProps.values.isMatchingEngineEnabled}
                                            onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                                formkikProps.setFieldValue('isMatchingEngineEnabled', checked);
                                            }
                                            }
                                        />
                                        <Separator alignContent="start"><b>{t("tradingSessions")}</b></Separator>


                                        <Stack horizontal horizontalAlign="space-between"  >
                                            <Stack.Item grow>

                                                <ComboBox
                                                    label={t("tradingDays")}

                                                    disabled={state.isLoading}
                                                    options={[{ key: 0, text: t("sunday") }, { key: 1, text: t("monday") }, { key: 2, text: t("tuesday") }
                                                        , { key: 3, text: t("wednesday") }, { key: 4, text: t("thursday") },
                                                    { key: 5, text: t("friday") }, { key: 6, text: t("saturday") }


                                                    ]}
                                                    selectedKey={formkikProps.values?.tradingDays}
                                                    allowFreeInput={false}
                                                    allowFreeform={false}
                                                    multiSelect
                                                    onChange={(e, o: any) => {

                                                        // Returns the day-of-week part of this DateTime. The returned value
                                                        // is an integer between 0 and 6, where 0 indicates Sunday, 1 indicates
                                                        // Monday, 2 indicates Tuesday, 3 indicates Wednesday, 4 indicates
                                                        // Thursday, 5 indicates Friday, and 6 indicates Saturday.
                                                        //
                                                        if (o) {
                                                            const list = formkikProps.values.tradingDays;
                                                            const key = o.key;

                                                            const newList = list.includes(key)
                                                                ? list.filter((item: any) => item !== key) // remove
                                                                : [...list, key];                   // add
                                                            formkikProps.setFieldValue(`tradingDays`, newList)
                                                        }

                                                    }}
                                                />
                                            </Stack.Item>
                                            <Stack.Item grow>
                                                <ComboBox
                                                    label={t("openingDay")}

                                                    disabled={state.isLoading}
                                                    options={[{ key: 0, text: t("sunday") }, { key: 1, text: t("monday") }, { key: 2, text: t("tuesday") }
                                                        , { key: 3, text: t("wednesday") }, { key: 4, text: t("thursday") },
                                                    { key: 5, text: t("friday") }, { key: 6, text: t("saturday") }


                                                    ].filter(day => formkikProps.values?.tradingDays.includes(day.key))}
                                                    selectedKey={formkikProps.values?.openingDay}
                                                    allowFreeInput={false}
                                                    allowFreeform={false}
                                                    onChange={(e, o: any) => {

                                                        // Returns the day-of-week part of this DateTime. The returned value
                                                        // is an integer between 0 and 6, where 0 indicates Sunday, 1 indicates
                                                        // Monday, 2 indicates Tuesday, 3 indicates Wednesday, 4 indicates
                                                        // Thursday, 5 indicates Friday, and 6 indicates Saturday.
                                                        //
                                                        if (o) {
                                                            formkikProps.setFieldValue(`openingDay`, o.key)
                                                        }

                                                    }}
                                                />
                                            </Stack.Item>


                                        </Stack>
                                        <Stack horizontal horizontalAlign="space-between"  >
                                            <Stack.Item grow>

                                                <TimePicker
                                                    strings={{ invalidInputErrorMessage: '' }}
                                                    label={t("from")}
                                                    placeholder={t("from")}
                                                    increments={15}
                                                    disabled={state.isLoading}
                                                    value={hhmmToDate(formkikProps.values.tradingHours[0])}
                                                    onChange={(_ev: React.FormEvent<IComboBox>, date: Date) => {
                                                        if (date != undefined && date != null && !isNaN(date.getTime())) {
                                                            formkikProps.setFieldValue("tradingHours", [dateToHHMM(date), formkikProps.values.tradingHours[1]])

                                                        } else {
                                                            formkikProps.setFieldValue("tradingHours", [0, formkikProps.values.tradingHours[1]])
                                                        }

                                                    }}

                                                />
                                            </Stack.Item>
                                            <Stack.Item grow>
                                                <TimePicker


                                                    label={t("to")}
                                                    strings={{ invalidInputErrorMessage: '' }}

                                                    placeholder={t("to")}
                                                    disabled={state.isLoading}
                                                    increments={15}
                                                    value={hhmmToDate(formkikProps.values.tradingHours[1])}
                                                    onChange={(_ev: React.FormEvent<IComboBox>, date: Date) => {
                                                        if (date != undefined && date != null && !isNaN(date.getTime())) {

                                                            formkikProps.setFieldValue("tradingHours", [formkikProps.values.tradingHours[0], dateToHHMM(date)])
                                                        } else {
                                                            formkikProps.setFieldValue("tradingHours", [formkikProps.values.tradingHours[0], 2359])

                                                        }

                                                    }}

                                                />
                                            </Stack.Item>
                                        </Stack>
                                    </Stack>
                                </PivotItem>


                            </Pivot>





                        </Stack>
                        <DialogFooter>
                            <PrimaryButton type="submit" disabled={state.isLoading} text={state.isLoading ? undefined : selectedKey == 0 ? t("next") : props.type == FormType.ADD ? t("add") : t("edit")} >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={selectedKey == 1 ? t("back") : props.type == FormType.ADD ? t("discard") : t("cancel")} onClick={() => {
                                if (selectedKey == 1) {
                                    onBackClick();
                                    return;
                                }
                                if (props.onCancel) {
                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>



                    </Form>
                )}
            </Formik >
        </>
    );

}

